import React from 'react';
import moment from 'moment';
import styles from '../Dashboards.mod.less';
import { recordTypeToMetaInfo } from '../helpers';

function ReportInfo({ selectedReport }) {
  if (!selectedReport) return null;

  const recordMetaInfo = recordTypeToMetaInfo(selectedReport.record_type);

  return (
    <div className={styles.ReportInfo}>
      {recordMetaInfo.image && (
        <div className={styles.ReportInfoImage}>
          <img src={recordMetaInfo.image} alt={recordMetaInfo.alt} />
        </div>
      )}
      <div className={styles.ReportInfoName}>
        <h4>
          <b>{selectedReport.name}</b>
        </h4>
      </div>
      <div className={styles.ReportInfoDetails}>
        <div>
          <span>Created by</span>
          <span className={styles.ReportInfoDetailsRight}>
            {selectedReport.user_name}
          </span>
        </div>
        <div>
          <span>Last modified</span>
          <span className={styles.ReportInfoDetailsRight}>
            {moment(selectedReport.updated_at).format('MMM D, YYYY')}
          </span>
        </div>
        <div>
          <span>Type</span>
          <span className={styles.ReportInfoDetailsRight}>
            {recordMetaInfo.type}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ReportInfo;
